module.exports = __webpack_public_path__ + "static/media/AllTextIcon.c160825b.svg";